import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import Http from "commons/Http";
import type { IResUserDetail } from "./myInfoVo";
import { API_USER } from "config/api";
import { createAppThunk, type IRes } from "store/modules/common";
// 이름 설정
const name = "user";

export interface IUser {
  userDetail?: IResUserDetail;
  businessDeleteFlag: boolean;
  walletDeleteFlag: boolean;
}

export const apiUserDetail = createAppThunk<{ data: IResUserDetail }>(`${name}/apiUserDetail`, async (_, thunkApi) => {
  const res = await Http.get<IRes<{ data: IResUserDetail }>>(`${API_USER}/detail`);
  if (res.data.content?.data) thunkApi.dispatch(rdxSetUserDetail(res.data.content.data));
  return res.data;
});

const insightSlice = createSlice({
  name,
  initialState: {
    userStore: undefined,
    businessDeleteFlag: false,
    walletDeleteFlag: false,
  } as IUser,
  reducers: {
    rdxSetUserDetail(state: IUser, action: PayloadAction<IResUserDetail>) {
      state.userDetail = action.payload;
    },
  },
});
export const { rdxSetUserDetail } = insightSlice.actions;
// data 를 관리하는 reducer 기본 반환 설정
export default insightSlice.reducer;
